function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 455 455",
    style: {
      enableBackground: "new 0 0 455 455"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC75"
    },
    d: "M227.5,0C101.86,0,0,101.86,0,227.5c0,47.55,14.6,91.69,39.54,128.19L9.66,445.34l89.65-29.88   C135.81,440.4,179.95,455,227.5,455C353.14,455,455,353.14,455,227.5S353.14,0,227.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98D9D5"
    },
    d: "M352.68,74.73c-20.16-16.54-43.66-29.17-69.32-36.72H171.64c-27.45,8.08-52.42,21.96-73.48,40.23   c0,0-34.74,39.31-34.75,39.3C42.31,148.97,30,186.8,30,227.5c0,36.27,9.77,70.26,26.84,99.47l110.88,88.82   c18.86,5.98,38.94,9.21,59.78,9.21c28.87,0,56.29-6.19,81.01-17.32l64.15-46.24c19.48-21.11,34.42-46.47,43.25-74.55L352.68,74.73z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.36,38.01c-3.89,27.37-27.42,48.42-55.86,48.42s-51.97-21.05-55.86-48.42   C189.35,32.8,208.1,30,227.5,30S265.65,32.8,283.36,38.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA8D6"
    },
    d: "M260.106,157.032c-4.142,0-7.5-3.358-7.5-7.5v-7.813c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5   v7.813C267.606,153.674,264.249,157.032,260.106,157.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA8D6"
    },
    d: "M352.68,74.73l0.332,28.169h-39.914c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5H333.1v20.591   h-31.43c-9.43,1.59-17.15,10.73-17.15,20.3v21.44h-55.79v21.4c0,15.41,12.49,27.89,27.89,27.89c13.02,0,23.95-8.91,27.03-20.97   h68.36c6.01,13.47,19.51,22.87,35.21,22.87v28.321H252.71c-13.24,0-23.98,10.73-23.98,23.97s10.74,23.98,23.98,23.98h26.58v54.259   c0,20.44,11.94,37.47,29.22,45.73c24.42-11,46.21-26.82,64.14-46.25v-74.54h43.26c5.91-18.74,9.09-38.7,9.09-59.39   C425,165.93,396.83,110.95,352.68,74.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA8D6"
    },
    d: "M161.74,314.85h-19.37v-5.5c0-23.62-19.14-42.76-42.76-42.76c-3.53,0-6.952,0.44-10.231,1.246   v-29.528c6.456-2.877,10.961-9.341,10.961-16.868v-14.47c2.534,0.65,24.512,0.464,39.87,0.248v9.753c0,4.142,3.358,7.5,7.5,7.5   s7.5-3.358,7.5-7.5V122.73c8.75-3.24,14.99-11.66,14.99-21.54c0-12.67-10.27-22.95-22.95-22.95c0,0-49.09,0-49.1-0.01   c-13.23,11.49-24.93,24.71-34.73,39.32v103.89c0,7.526,4.504,13.99,10.959,16.868v36.52c-10.63,7.777-17.539,20.344-17.539,34.522   v17.62c24.45,41.85,63.85,73.9,110.88,88.81v-43.54c13.15-2.76,23.03-14.42,23.03-28.39C190.75,327.84,177.76,314.85,161.74,314.85   z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.e060ec48.svg";
export { ForwardRef as ReactComponent };